import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';

@Injectable()
export class ClaimsService {
    private static userIdKey = 'userId';
    private static userTypeIdKey = 'userTypeId';
    private static firstNameKey = "firstName";
    private static lastNameKey = "lastName";
    constructor(private storageService: StorageService) { }

    public setUserId(userId: number) {
        if (userId === null || userId === 0) {
            this.storageService.remove(ClaimsService.userIdKey);
        }
        else {
            this.storageService.set(ClaimsService.userIdKey, userId);
        }
    }

    public setUserTypeId(userTypeId: number) {
        if (userTypeId === null || userTypeId === 0) {
            this.storageService.remove(ClaimsService.userTypeIdKey);
        }
        else {
            this.storageService.set(ClaimsService.userTypeIdKey, userTypeId);
        }
    }

    public setFirstName(firstName: string) {
        if (firstName === null || firstName === '') {
            this.storageService.remove(ClaimsService.firstNameKey);
        }
        else {
            this.storageService.set(ClaimsService.firstNameKey, firstName);
        }
    }

    public setLastName(lastName: string) {
        if (lastName === null || lastName === '') {
            this.storageService.remove(ClaimsService.lastNameKey);
        }
        else {
            this.storageService.set(ClaimsService.lastNameKey, lastName);
        }
    }

    public getUserId(): number {
        return this.storageService.get<number>(ClaimsService.userIdKey);
    }

    public getUserTypeId(): number {
        return this.storageService.get<number>(ClaimsService.userTypeIdKey);
    }

    public getFirstName(): string {
        return this.storageService.get<string>(ClaimsService.firstNameKey);
    }

    public getLastName(): string {
        return this.storageService.get<string>(ClaimsService.lastNameKey);
    }

    public isSambaAdmin(): boolean {
        return this.getUserTypeId() === 1;
    }

    public isPublisherAdmin(): boolean {
        return this.getUserTypeId() === 2;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/claims.service.ts